import { useEffect, useRef } from 'react';

// returns a ref that always points to the latest value passed to it
// useful for when you need to access the the most up-to-date value in a callback / closured scope
const useLatest = <T>(value: T) => {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
};

export default useLatest;
